import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

//Components
import Loading from '../../components/Loading/Loading';

//Api
import MTR_api from '../../api/MTR_api';

//Helpers
import { showMessage } from '../../helpers/message';
import mascaras from '../../helpers/mascaras';


export default function RelatorioMTR() {
    const location = useLocation();

    //Estado que guarda os caminhos das imagens da mtr
    const [imagens, setImagens] = useState([]);

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Mtr recebida para carregar os dados
    const mtr = location.state.mtr;

    //Carrega as imagens da mtr e o caminho da logo
    useEffect(() => {
        setLoading(true);
        MTR_api.GetImagensMtr(mtr.codigoMTR).then(response => {
            setImagens(response.data);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }, []);
    return (
        <>
            {loading && <Loading />}
            <div className={`p-0 rounded mainContainerFicha mt-0`}>
                <div className="shadowFicha rounded-3 m-2 px-2 py-2" >
                    <h5 className="p-2 titleFicha">Gerador</h5>
                    <div className="row">
                        <div className="col-6">
                            <p><span className="fw-bold">Nome/Razão Social:</span> {mtr.gerador}</p>
                        </div>
                        <div className="col-6">
                            <p><span className="fw-bold">CPF/CNPJ:</span> {mascaras.cpfcnpjMask(mtr.cnpjGerador)}</p>
                        </div>

                        <div className="col-12">
                            <p>
                                <span className="fw-bold">Endereço:</span> {mtr.geradorEndereco}
                            </p>
                        </div>

                        <div className="col-3">
                            <p>
                                <span className="fw-bold">Responsável:</span>{mtr.responsavelGerador}
                            </p>
                        </div>
                        <div className="col-5">
                            <p>
                                <span className="fw-bold">E-mail</span>  {mtr.emailGerador}
                            </p>
                        </div>
                        <div className="col-4">
                            <p>
                                <span className="fw-bold">Telefone:</span>  {mascaras.celularMask(mtr.telefoneGerador)}
                            </p>
                        </div>
                        <div className="col-12 mb-3">
                            <span className="fw-bold">Identificação do Gerador (QR Code):</span> {mtr.tag}
                        </div>
                    </div>
                </div>

                <div className="shadowFicha rounded-3 m-2 px-2 py-2">
                    <h5 className="p-2 titleFicha">Transportador</h5>
                    <div className="row ">
                        <div className="col-12">
                            <p>
                                <span className="fw-bold">Razão Social:</span> {mtr.transportador}
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <p>
                                <span className="fw-bold">CNPJ:</span> {mascaras.cnpjMask(mtr.cnpjTransportador)}
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <p>
                                <span className="fw-bold">Endereço:</span> {mtr.transportadorEndereco}
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className='col-6'>
                            <p>
                                <span className="fw-bold">Licença/Validade:</span> {mtr.operacaoNumero} / {mtr.operacaoValidade}
                            </p>
                        </div>
                        <div className="col-6">
                            <p>
                                <span className="fw-bold">Credenciamento/Validade:</span> {mtr.credenciamentoNumero} / {mtr.credenciamentoValidade}
                            </p>
                        </div>
                    </div>
                </div>

                <div className="shadowFicha rounded-3 m-2 px-2 py-2">
                    <h5 className="p-2 titleFicha">Dados da coleta</h5>
                    <div className="row">
                        <div className="col-12">
                            <p>
                                <span className="fw-bold">Endereço da coleta:</span> {mtr.geradorEndereco}
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <p><span className="fw-bold">Modalidade da Coleta: </span> {mtr.modalidade}</p>
                        </div>
                        <div className="col-6">
                            <p><span className="fw-bold">Tipo Residuo:</span> {mtr.residuos}</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <p><span className="fw-bold">Total Coletado:</span> {mtr?.volumeColetado} {mtr?.unidade?.toUpperCase()}</p>

                        </div>
                        <div className="col-6">
                            <p><span className="fw-bold">Placa do Veículo:</span> {mtr.placaVeiculo}</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <p><span className="fw-bold">Data/Hora da Coleta:</span> {mtr.dataColetada}</p>
                        </div>
                        {!!mtr.observacaoOperador &&
                            <div className="col-12">
                                <p><span className="fw-bold">Observação do Operador:</span> {mtr.observacaoOperador}</p>
                            </div>
                        }
                    </div>
                </div>

                <div className="shadowFicha rounded-3 m-2 px-2 py-2">
                    <h5 className="p-2 titleFicha"> Destino</h5>
                    <div className="row">
                        <div className="col-6">
                            <p><span className="fw-bold">Razão Social:</span> {mtr.destino}</p>
                        </div>
                        <div className="col-6">
                            <p><span className="fw-bold">CNPJ:</span> {mascaras.cnpjMask(mtr.cnpjDestino)}</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <p><span className="fw-bold">Endereço:</span> {mtr.destinoEndereco}</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <p><span className="fw-bold">Licença/Validade:</span> {mtr.licencaDestino} / {mtr.validadeDestino}</p>
                        </div>
                        <div className="col-6">
                            <p><span className="fw-bold">Total Recebido:</span> {mtr.pesoRecebido} Kg</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <p><span className="fw-bold">Data/Hora de Recebimento:</span> {mtr.dataEntrada}</p>
                        </div>
                    </div>
                </div>

                <div className="shadowFicha rounded-3 m-2 p-2">
                    <h5 className="p-2 titleFicha "> Imagens</h5>
                    {imagens.map(value => {
                        if (value != "") {
                            return (<div className="col-4 p-1 ">
                                <img
                                    width="250px"
                                    height={"100px"}
                                    id="img_anexo"
                                    src={value}
                                    className='rounded'
                                />
                            </div>);
                        }
                    })}
                </div>
            </div>
        </>
    );
}